import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, VIEW, ASC } from "const"
import { MtProject } from "server/models"
import {
    StateType,
    hasAccess,
    hasProjectAccess,
} from "client/utils"
import {
    PRM_SIL_SUBSYSTEM,
    StoreType,
    SilSubsystemProps,

    LoadAllProjects,
    LoadProjectUserGroups,
    LoadProjectPermissions,
    LoadSilDeviceById,
    SortProjects,

    setProjectList,
    setProjectIds,
    setSystemProjectUserGroups,
    setSystemProjectPermissions,
    setSilDeviceView,
    setSilDeviceNestedCurrentList,

    moduleIds,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import NotFound from "client/parts/notFound"
import Form from "./form"
import Model from "./model"
import DetailsByUser from "./detailsByUser"
import Results from "./results"

const SubsystemView = ({
    subsystemId = null,
}: SilSubsystemProps) => {
    const subsystem = useSelector((state: StoreType) => state.silDevice.deviceView)
    const reloadView = useSelector((state: StoreType) => state.silDevice.reloadView)

    const project = useSelector((state: StoreType) => state.project.projectView)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadCopyState, setLoadCopyState] = useState<StateType>(IDLE)
    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        // load data for Copy function
        setLoadCopyState(PENDING)
        LoadAllProjects(userData.accountId).then((res) => {
            dispatch(setProjectList(res))

            const projectsWithSil: MtProject[] = []
            Object.values(res).forEach((row) => {
                const projectModules = JSON.parse(row.modules)
                if (projectModules[moduleIds.sil]) projectsWithSil.push(row)
            })

            const sortedIds = SortProjects(projectsWithSil, "name", ASC, {})
            dispatch(setProjectIds(sortedIds))

            const promiseArray: Promise<any>[] = []
            projectsWithSil.forEach((projectRow) => {
                promiseArray.push(
                    // to check user access to selected project
                    LoadProjectUserGroups(userData.userId, userData.accountId, projectRow.id)
                    .then((projectGroupIds) => {
                        dispatch(setSystemProjectUserGroups(projectRow.id, projectGroupIds))
                    }),
                    LoadProjectPermissions(userData.accountId, projectRow.id)
                    .then((permissions) => {
                        dispatch(setSystemProjectPermissions(projectRow.id, permissions.permissions))
                    }),
                )
            })
            Promise.all(promiseArray).then(() => {
                setLoadCopyState(IDLE)
            })
        })
    }, [])

    useEffect(() => {
        if (!reloadView) return
        setLoadState(PENDING)
        LoadSilDeviceById(subsystemId, userData.accountId, project.id).then((res) => {
            dispatch(setSilDeviceView(res))
            dispatch(setSilDeviceNestedCurrentList(res.nestedDevices))
        }).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadView])

    const viewAccess = !project.id
        ? hasAccess(PRM_SIL_SUBSYSTEM, VIEW)
        : hasProjectAccess(PRM_SIL_SUBSYSTEM, VIEW)

    if (!viewAccess) return <AccessDenied />
    if (!subsystem) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{`${lang.viewSubsystem} # ${subsystem.id || ""}`}</PageTitle>
            </PageHeader>
            <PageContent>
                {
                    (
                        loadCopyState === PENDING
                        || loadState === PENDING
                    ) && <Loader />
                }
                <Form />
                <Model />
                <DetailsByUser />
                <Results />
            </PageContent>
        </Container>
    )
}
export default SubsystemView
